




















import InputFieldGenerator                              from "@/components/pageGenerator/InputFieldGenerator.vue";
import { FieldScheme, InputFieldType, StaticFieldType } from "@/components/pageGenerator/models";
import StaticFieldGenerator                             from "@/components/pageGenerator/StaticFieldGenerator.vue";
import { Component, Prop, PropSync, Vue }               from "vue-property-decorator";

@Component({
  name      : "FieldGenerator",
  components: {InputFieldGenerator, StaticFieldGenerator}
})
export default class FieldGenerator extends Vue {
  @Prop({
    required: true,
    type    : Array as () => FieldScheme[],
    default : () => {
      return [];
    }
  })
  private fields!: FieldScheme[];
  private StaticFieldType = StaticFieldType;
  private InputFieldType  = InputFieldType;

  @PropSync("fieldData")
  private fieldDataSynced!: unknown;
}
